module.exports = __webpack_public_path__ + "static/media/icon.ddf36120.svg";